import React from 'react'
import { Link } from 'react-router-dom'

const FindLandDetail = () => {
    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>Find Land Detail</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="service-detail all-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-4 col-md-4">
                            <div className="service-detail-main-img">
                                <img src="images/s-1.jpg" alt />
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-5">
                            <div className="service-detail-main-txt">
                                <h3>Organic Farming Land </h3>
                                <h3>$200 (Monthly)</h3>
                                <ul className="srv_disnone">
                                    <li>
                                        <img src="images/full-size.png" alt />
                                        <span>100 – 250 sqm</span>
                                    </li>
                                    <li>
                                        <img src="images/location.png" alt />
                                        <span>Demo Allotment Plot 2 45 Meadow</span>
                                    </li>
                                </ul>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                                    exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
                                    dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                    Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
                                    mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                                    eiusmod tempor</p>
                                <Link to="/payment-options" className="theme_btn1 mt-3">
                                    <div className="theme-btn-inner1">
                                        <div className="btn-text1">View Payment Options</div>
                                        <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3">
                            <div className="land_owner_dlt">
                                <ul>
                                    <li>
                                        <img src="images/land-o.jfif" alt />
                                    </li>
                                    <li>
                                        <h4>Joseph M. <p>(Land Owner)</p>
                                        </h4>
                                        <span>verified</span>
                                        <div className="ratingg">
                                            <i className="fa-solid fa-star" />
                                            <i className="fa-solid fa-star" />
                                            <i className="fa-solid fa-star" />
                                            <i className="fa-solid fa-star" />
                                            <i className="fa-regular fa-star" />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FindLandDetail